/** Translucent tint of a colour, mirroring the prototype's `mix()` helper. */
export function mix(color: string, alpha: number): string {
  return `color-mix(in oklab, ${color} ${Math.round(alpha * 100)}%, transparent)`
}
